import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';

import { planApiKeyStore } from '../../api/plan-api-key-store';
import { useSaveData } from '../../hooks/useSaveData';
import { useReactHookForm } from "../../hooks/useReactHookForm";
import { ReactHookForm } from "../../components/hook-form/react-hook-form.component";
import { FormSelect } from "../query-builder/hooks-form-querybuilder/form-select.component";
import { useAuthorize } from "../../hooks/use-authorize";
import { UserPermissionName } from "../../models/user-permission-name";

const styling = {
    dialogTitleStyle: { padding: '16px 24px 0' },
    contentPadding: { paddingTop: '30px' },
};

interface PlanStatusDialog {
    statusValue: any;
    isPlanLoading: boolean;
    refetching: () => void;
    onClosed: () => void
}

const orderOption = [
    {
        value: 'active',
        label: 'Active',
        isDefault: false,
    },
    {
        value: 'inactive',
        label: 'Inactive',
        isDefault: false,
    },
];

export const planStatusFormSchema = Yup.object().shape({
    planStatus: Yup.string().required('Status is required'),
});

export const PlanStatusDialog = ({ statusValue, refetching, isPlanLoading, onClosed }: PlanStatusDialog) => {

    const form = useReactHookForm({
        defaultValues: {
            planID: statusValue?.planID,
            planStatus: statusValue?.isActive ? 'active' : 'inactive'
        },
        yupSchema: planStatusFormSchema
    });

    const { isLoading, isError, error, mutateAsync } = useSaveData<any>(planApiKeyStore.updatePlanStatus());

    const submitHanlder = async (value: any) => {
        const statusData = {
            planID: value?.planID,
            isActive: Boolean(value?.planStatus == 'active' ? true : false),
        }
        await mutateAsync({ data: statusData });
        refetching();
        onClosed();
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={'sm'}
            // onClose={handleClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
                CHANGE STATUS
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClosed}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 9,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <DialogContent dividers style={styling.contentPadding} className="popupDilog">
                <ReactHookForm formName="PLAN_STATUS_FORM" onSubmit={submitHanlder} formContextProps={form}>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <FormSelect
                                name="planStatus"
                                label="Status"
                                options={orderOption}
                            // required
                            />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <div className="spaceBetween">
                                <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
                                    Cancel
                                </Button>
                                <Button type='submit' variant="contained" style={{ width: '130px' }}
                                    disabled={isLoading || isPlanLoading || isReadOnlyPermission}>
                                    Save
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </ReactHookForm>
            </DialogContent>
        </Dialog>
    );
}